import {gql} from '@apollo/client';

import {ImplementedAntibodySchemaInterfacesQuery} from 'antibodies/hooks/__generated/ImplementedAntibodySchemaInterfacesQuery';
import BenchlingConfig from 'BenchlingConfig';
import {QueryResultType, useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

type ImplementedAntibodySchemaInterface =
  ImplementedAntibodySchemaInterfacesQuery['allImplementedAntibodySchemaInterfaces'][number];

export const IMPLEMENTED_ANTIBODY_SCHEMA_INTERFACES_QUERY = gql`
  query ImplementedAntibodySchemaInterfacesQuery @skipAudit @engComponent(name: ANTIBODIES) {
    allImplementedAntibodySchemaInterfaces {
      id
      format {
        ...AntibodyFormatGraphQL
      }
      schema {
        id
        iconId
        name
        archived
      }
      schemaInterface {
        id
      }
    }
  }
  ${getFragmentWrapper('AntibodyFormat').fragment}
`;

/**
 * Fetches all implemented antibody schema interfaces, including the full format for each. Skips if antibodies
 * are not enabled.
 */
export function useImplementedAntibodySchemaInterfacesQuery(): {
  /* The current status of the query */
  status: QueryResultType;
  /* The schema interfaces. Returns empty list if skipped, or if the query is not successful. */
  schemaInterfaces: Array<ImplementedAntibodySchemaInterface>;
} {
  const result = useSkippableBenchlingQuery<ImplementedAntibodySchemaInterfacesQuery>(
    IMPLEMENTED_ANTIBODY_SCHEMA_INTERFACES_QUERY,
    {
      skip: !BenchlingConfig.MOLBIO_ENABLE_ANTIBODY_ENTITIES,
    }
  );

  if (result.type !== QueryResultType.SUCCESS) {
    return {status: result.type, schemaInterfaces: []};
  }

  return {
    status: QueryResultType.SUCCESS,
    schemaInterfaces: result.data.allImplementedAntibodySchemaInterfaces,
  };
}
